$.validator.setDefaults({
    ignore: [],
});

//enables show/hide password whilst typing 
document.addEventListener("DOMContentLoaded", function () {
    // Look for any toggle buttons with .toggle-password
    document.querySelectorAll(".toggle-password").forEach(function (button) {
        button.addEventListener("click", function () {
            // Get the target input (via data-target attribute)
            const inputId = this.getAttribute("data-target");
            const passwordInput = document.getElementById(inputId);

            if (!passwordInput) return;

            const type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
            passwordInput.setAttribute("type", type);

            // Toggle icon/text
            this.textContent = type === "password" ? "👁" : "🙈";
        });
    });
});

$.validator.unobtrusive.adapters.addBool("checkboxrequired", "required");

$(window).on("load", function () {
    hideLoadingScreen();

    $(".ReCaptchaUtilSubmitButton").removeAttr('disabled');
    
    // Standard form submission with validation
    $('.loading-form').on('submit', function (e) {
        var $form = $(this);
        if ($form.valid()) {
            showLoadingScreen();
        }
    });

    // Form submission without recaptcha
    $(".loading-form-no-recaptcha").on("submit", function () {
        var form = $(this);
        var formId = form.attr('id');
        var submitButton = form.find("input[type='submit'], button[type='submit']");

        if (!form.valid()) return;

        submitButton.attr('disabled', 'disabled');
        showLoadingScreen();
    });

    $(".ReCaptchaUtilSubmitButton").on('click', function (e) {
        e.preventDefault();
        var button = $(this);
        var siteKey = button.attr('data-sitekey');
        var form = button.closest('form');
        hideLoadingScreen();
        button.removeAttr('disabled');
        if (!form.valid()) return;
        button.attr('disabled', 'true');
        showLoadingScreen();
        grecaptcha.ready(function () {
            grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
                $(".GoogleReCaptchaToken").val(token);
                SetSpamData(form);
            });
        });
    });
});

// Custom Field Types
$(document).on('DOMContentLoaded', function () {
    $('.multipleSelectCheckbox').each(function () {
        var noneText = $(this).attr('placeholder') || '-- Select Options --'; // Fallback text if placeholder is not set
        $(this).multiSelect({ 'noneText': noneText });
    });

    RenderSummernoteSimpleByCssClass("textarea-editor", 120);

    new DG.OnOffSwitch({
        el: '.on-off-switch-custom',
        height: 40,
        trackColorOn: '#1B264F',
        trackColorOff: '#666',
        trackBorderColor: '#555',
        textColorOff: '#fff',
        textOn: 'YES',
        textOff: 'NO'
    });

    $('.tagsinput').tagsinput({
        trimValue: true,
        confirmKeys: [13, 44] // Enter or comma
    });
});
// End Custom Field Types

function RenderSummernoteSimpleById(id, height, reset = false) {

    if (reset) {
        $('#' + id).summernote('reset');
        $('#' + id).summernote('destroy'); 
    }

    $('#' + id).summernote({
        placeholder: '',
        tabsize: 2,
        height: height,
        toolbar: [
            ['font', ['bold', 'underline', 'italic']],
            ['para', ['ul', 'ol']]
        ],
        callbacks: {
            onPaste: function (e) {
                e.preventDefault();

                let clipboardData = (e.originalEvent || e).clipboardData;
                let html = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

                // Clean the pasted content
                let cleanHtml = DOMPurify.sanitize(html, {
                    ALLOWED_TAGS: ['b', 'i', 'u', 'ul', 'ol', 'li', 'p', 'br'],
                    ALLOWED_ATTR: [] // no style/class/etc
                });

                // Insert cleaned HTML via Summernote API
                $(this).summernote('pasteHTML', cleanHtml);
            }
        }
    });
}

function RenderSummernoteSimpleByCssClass(cssClass, height, reset = false) {

    if (reset) {
        $('.' + cssClass).summernote('reset');
        $('.' + cssClass).summernote('destroy');
    }

    $('.' + cssClass).summernote({
        placeholder: '',
        tabsize: 2,
        height: height,
        toolbar: [
            ['font', ['bold', 'underline', 'italic']],
            ['para', ['ul', 'ol']]
        ],
        callbacks: {
            onPaste: function (e) {
                e.preventDefault();

                let clipboardData = (e.originalEvent || e).clipboardData;
                let html = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

                // Clean the pasted content
                let cleanHtml = DOMPurify.sanitize(html, {
                    ALLOWED_TAGS: ['b', 'i', 'u', 'ul', 'ol', 'li', 'p', 'br'],
                    ALLOWED_ATTR: [] // no style/class/etc
                });

                // Insert cleaned HTML via Summernote API
                $(this).summernote('pasteHTML', cleanHtml);
            }
        }
    });
}

function ReCaptchaUtilEnableButton() {
    SetSpamData();
    $(".ReCaptchaUtilEnableButton").removeAttr("disabled");
}

function SetSpamData(form) {
    var enable = $(".SpamEnableIpLookup").val();
    var endpoint = $(".SpamIpLookupEndpoint").val();
    var key = $(".SpamIpLookupApiKey").val();
    var publicKey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB16+irbI7AKZrJCD3eb7IS
u60scvITfiKZfEbA5mQe0TypknyHSOpZK2vHKJy4wyBD40EyQhl/MkDIij0X0T5U
/XZkafid3NbgIb8eLmB/cuKV/woslx86qvn4DNm3+OAUO1gTYWOvYDnJ17v6Ta9x
IniJoaMPs55pCnGBZx9RDHA3fAZeGZAT5u4kEIuPyGY7VyHmE3qbaoHdze0rbJH5
BW3eoJkWus0YTWDP+NXWoTr8e9lCw8XGQK81oCgrgp7myVO3K7KPO+UfQsGJKc+R
iCRXFRC+H2gI0LuEBrVBCVNn0P+qMKkV+3F7hG+xeb5L0G5RMVi+KYCOvfY80BCN
AgMBAAE=
-----END PUBLIC KEY-----`;

    if (enable === "True") {
        $.getJSON(endpoint + key, function (data) {
            var encrypt = new JSEncrypt();
            encrypt.setPublicKey(publicKey);

            $(".LookupAddress").val(encrypt.encrypt(data.ip));
            $(".LookupContinent").val(encrypt.encrypt(data.continent));
            $(".LookupCountry").val(encrypt.encrypt(data.country));

            console.log("Encrypted IP: " + $(".LookupAddress").val());
            if (form) form.submit();
        });

    } else {
        if (form) form.submit();
    }
}

function hideLoadingScreen() {
    $(".loading-screen").fadeOut("slow");
}

function showLoadingScreen() {
    const loader = document.querySelector('.loading-screen');
    if (!loader) return;

    // Make sure it's visible again
    loader.style.display = "flex";

    // Grab values from hidden fields
    const backgroundColor = document.getElementById('loading-bg-colour').value || '000000';
    const iconColor = document.getElementById('loading-icon-colour').value || 'FF00AA';
    const iconSize = document.getElementById('loading-icon-size').value || '80';

    loader.style.backgroundColor = `#${backgroundColor}`;
    loader.innerHTML = '';

    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("class", "loader-icon");
    svg.setAttribute("viewBox", "0 0 200 200");
    svg.setAttribute("width", iconSize);
    svg.setAttribute("height", iconSize);

    [40, 100, 160].forEach((cx, i) => {
        const circle = document.createElementNS(svgNS, "circle");
        circle.setAttribute("class", "dot");
        circle.setAttribute("cx", cx);
        circle.setAttribute("cy", 100);
        circle.setAttribute("r", 15);
        circle.setAttribute("stroke-width", 15);
        circle.setAttribute("fill", `#${iconColor}`);
        circle.setAttribute("stroke", `#${iconColor}`);
        circle.style.animation = `blink 2s infinite`;
        circle.style.animationDelay = `${-0.2 * (i + 1)}s`;
        svg.appendChild(circle);
    });

    loader.appendChild(svg);
}